// extracted by mini-css-extract-plugin
export default {"form-container":"LogInForm_form-container__VjOqN","forgotPassword":"LogInForm_forgotPassword__PAaYx"};